import type { ScheduleDateVo, ScheduleVo } from "@zhihaoscm/entity";
import { dateFormat } from "@zhihaoscm/utils";
import { LOG_DATE_FORMAT_START } from "@/config";

// 排期项
export interface ScheduleItem {
    companyName: string;
    phone: string;
    scheduleId: string;
    shipInfo: string;
    waybillId: string;
    estimatedVolume: number;
    selected: boolean;
    // remainingQuantity: number;
    // extra 额外本地使用字段
    isEdit: boolean; // 是否在编辑状态
    isExpand: boolean; // 是否展开状态
}

// 排期日历 - 一天的排期数据
export interface IScheduleDateVo extends ScheduleDateVo {
    scheduleDate: string; // 日期
    scheduledQuantity?: number; // 已排
    remainAvailablePickedUpTon: number; // 剩余可提
    // schedules: ScheduleItem[];
    scheduleVos: ScheduleVo[];
    // extra
    estimatedQuantity?: number; // 预估可提
    weekday: string; // 星期几
    isEdit: boolean; // 是否在编辑状态
    isExpand: boolean; // 是否展开状态
    lastTimeEstimatedQuantity?: number; // 上次编辑的值（用于单个取消）
    originalEstimatedQuantity?: number; // 最原始的值（用于全局取消）
}

// 获取今天后2个月的时间
export const getTimeTwoMonthLater = (dateTime?: string) => {
    // 获取当前日期时间
    const now = dateTime ? new Date(dateTime) : new Date();

    // 计算2个月后的日期
    const resultDate = new Date(now);
    resultDate.setMonth(resultDate.getMonth() + 2);

    // 处理日期溢出情况（如1月31日 +2个月 = 3月31日）
    if (now.getDate() !== resultDate.getDate()) {
        // 如果日期变化了，说明遇到了小月份，设置为该月最后一天
        resultDate.setDate(0); // 设置为上个月的最后一天
    }

    // 格式化输出
    const formatNumber = (num: number) => num.toString().padStart(2, "0");
    const formattedDate = [
        resultDate.getFullYear(),
        formatNumber(resultDate.getMonth() + 1),
        formatNumber(resultDate.getDate())
    ].join("-");

    const formattedTime = [
        formatNumber(resultDate.getHours()),
        formatNumber(resultDate.getMinutes()),
        formatNumber(resultDate.getSeconds())
    ].join(":");

    return `${formattedDate} ${formattedTime}`;
};

// 根据日期计算出星期几
export const getWeekday = (date: string) => {
    const weekdays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    const day = new Date(date).getDay();
    return weekdays[day];
};

// 相对今天，是否是过去时间， 不包含今天
export const isPast = (scheduleDate: string | Date) => {
    const scheduleStartMs = new Date(dateFormat(scheduleDate, LOG_DATE_FORMAT_START)).getTime();
    const todayStartMs = new Date(dateFormat(new Date(), LOG_DATE_FORMAT_START)).getTime();
    return scheduleStartMs < todayStartMs;
};
